module.exports = __webpack_public_path__ + "img/3.dfb86be1.jpg";